<div class="order-card" [ngClass]="[fulfillmentClass]">
  <div>
    <img
      class="order-card__image"
      [ngClass]="{ large: isPickAndPackFocus }"
      [src]="getItemImage(orderItem.variant?.image || orderItem.product?.image)"
      alt="" />
  </div>
  <div class="order-card__content-wrapper">
    <div class="order-card__main-content-wrapper">
      <div class="order-card__content">
        <h2 class="order-card__content__title">
          {{ orderItem.product.name }}
        </h2>
        <ul [ngClass]="{ single: true }">
          @if (orderItem.variant?.option1) {
            <li>
              {{ orderItem.variant.option1 }}
            </li>
          }
          @if (orderItem.variant?.option2) {
            <li>
              {{ orderItem.variant.option2 }}
            </li>
          }
          @if (orderItem.variant?.option3) {
            <li>
              {{ orderItem.variant.option3 }}
            </li>
          }
          <li class="order-card__content__sku">SKU: {{ orderItem.sku || '' }}</li>
        </ul>
        @if (orderItem?.properties?.length > 0) {
          <div>
            <p (click)="showProperties = !showProperties" class="show_properties">
              {{ orderItem.properties.length }} more properties
              <img
                class="button__icon"
                [ngClass]="{ open: showProperties }"
                src="'../../../../../../assets/images/polygon_2.png"
                alt="" />
            </p>
            @if (showProperties) {
              <ul class="show_properties_list">
                @for (property of orderItem.properties; track property) {
                  <li>
                    {{ property }}
                  </li>
                }
              </ul>
            }
          </div>
        }
        @if (!isDigital && hasBox && isMultiParcel) {
          <div class="property">
            <div class="property__name">Package:</div>
            <div class="property__value">{{ box }}</div>
            <pdq-button variant="ghost" size="medium" icon="edit-1" (onClick)="switchPackage()"> </pdq-button>
          </div>
        }
        @if (!isDigital) {
          <div class="order-card__weight">
            @if (isSupportsMeasurments) {
              <div>
                <span [style.fontWeight]="500">Weight: </span>
                <span>{{ itemWeight }}</span>
                @if (weightFromPlatform) {
                  <span>
                    <img src="../../../../../../assets/icons/shopify.svg" />
                  </span>
                }
              </div>
            }
            <!-- <span class="order-card__weight__package"></span> -->
          </div>
        }
        @if (isDigital) {
          <pdq-tag variant="quaternary">Shipping not required</pdq-tag>
        }
        @if (orderItem.holdQuantity) {
          <pdq-tag variant="tertiary"
            >Contains {{ orderItem.holdQuantity }} on-hold item{{ orderItem.holdQuantity > 1 ? 's' : '' }}</pdq-tag
          >
        }
      </div>
      @if (!isDigital && !itemFulfilled && !isPickingMode) {
        <div class="order-card__counter">
          <pdq-input-number
            [disabled]="
              hasBundle ||
              perItemFulfillNotSupportedByPlatform ||
              disableActions ||
              orderItem.quantity <= (orderItem.holdQuantity || 0) ||
              isDisableManualFulfillment
            "
            [value]="
              disableActions ? 0 : orderItem.quantity - (orderItem.holdQuantity || 0) - orderItem.fulfillableQuantity
            "
            [max]="orderItem.quantity - (orderItem.holdQuantity || 0)"
            [min]="orderItem.quantity - (orderItem.holdQuantity || 0) - orderItem.fulfillableQuantity"
            (onChange)="updateFulfillmentQuantity($event)"
            [displayMinMax]="!includeAccessory && !includeMultiItemsOrder"
            #counter></pdq-input-number>
          <div class="to-be-fulfilled">To be fulfilled</div>
        </div>
      }
      @if (!isDigital && !itemFulfilled && isPickingMode) {
        <div class="order-card__counter">
          <pdq-input-number
            [disabled]="hasBundle || perItemFulfillNotSupportedByPlatform || disableActions"
            [value]="
              disableActions
                ? 0
                : orderItem.quantity -
                    (orderItem.pickableQuantity !== null && orderItem.pickableQuantity !== undefined
                      ? orderItem.pickableQuantity + (orderItem.holdQuantity || 0)
                      : orderItem.quantity) || isDisableManualFulfillment
            "
            [max]="orderItem.quantity"
            [min]="
              orderItem.quantity -
              (orderItem.holdQuantity || 0) -
              (orderItem.pickableQuantity !== null && orderItem.pickableQuantity !== undefined
                ? orderItem.pickableQuantity + (orderItem.holdQuantity || 0)
                : orderItem.quantity)
            "
            [displayMinMax]="!includeAccessory && !includeMultiItemsOrder"
            (onChange)="updatePickmentQuantity($event)"
            #pickingCounter></pdq-input-number>
          <div class="to-be-fulfilled">To be picked</div>
        </div>
      }
      <div class="order-card__status-icon">
        <span>{{ currencySign }}{{ orderItem.price }} x {{ orderItem.quantity }}</span>
        <span class="order-card__status-icon-details">
          @if (!isDigital && isPickingMode) {
            <pdq-tag class="tag" variant="quaternary" maxWidth="150" [value]="pickmentTagValue"></pdq-tag>
          }
          <pdq-icon class="icon" [icon]="statusIcon" [color]="statusIconColor"></pdq-icon>
        </span>
      </div>
    </div>
    @if (isSupportTracingNumber && !isDigital) {
      <div class="tracing_number">
        <p (click)="showTracingNumber = !showTracingNumber" class="show_properties">
          Add tracing number ({{ tracingNumbers.length }})
          <img
            class="button__icon"
            [ngClass]="{ open: showTracingNumber }"
            src="'../../../../../../assets/images/polygon_2.png"
            alt="" />
        </p>
        @if (showTracingNumber) {
          <div>
            <div
              class="tracing_number_field"
              [ngClass]="{ error: tracingNumbersError }"
              (click)="onTracingNumberEnter()"
              (focusout)="onTracingNumberLostFocus($event)">
              @if (tracingNumbers.length) {
                @for (tracingNumber of tracingNumbers; track tracingNumber; let chipIndex = $index) {
                  <pdq-chip
                    class="tracing_number_chip"
                    [label]="tracingNumber"
                    (onChange)="onTracingNumberRemove(chipIndex)">
                  </pdq-chip>
                }
              }
              <pdq-input
                #tracingNumberInput
                class="tracing_number_input"
                placeholder=" "
                [autofocus]="true"
                [background]="'transparent'"
                [offsetPositionX]="-100"
                [border]="false"
                width="auto"
                (keydown.enter)="onTracingNumberAdd($event)">
              </pdq-input>
            </div>
            <p class="tracing_number_errors" [ngClass]="{ visible: tracingNumbersError }">
              <img src="'../../../../../../assets/icons/banner-danger-icon.svg" alt="" />
              {{ tracingNumbersError }}
            </p>
            <div class="tracing_number_button_wrapper">
              <pdq-button
                label="Update"
                variant="dark"
                [loading]="isTracingNumberLoading"
                (click)="saveTracingNumbers()"></pdq-button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
